(function () {
    'use strict';

    function initializeReviews() {
        document.querySelectorAll('[data-google-reviews]').forEach(function (section) {
            if (section.googleReviewsInitialized) return;
            section.googleReviewsInitialized = true;

            var cards = Array.from(section.querySelectorAll('[data-review-card]'));
            var stage = section.querySelector('[data-review-stage]');
            var track = section.querySelector('[data-review-track]');
            var previous = section.querySelector('[data-review-prev]');
            var next = section.querySelector('[data-review-next]');
            var controls = section.querySelector('[data-review-pagination]');
            var currentPage = section.querySelector('[data-review-page]');
            var totalPages = section.querySelector('[data-review-pages]');
            var desktop = window.matchMedia('(min-width: 992px)');
            var tablet = window.matchMedia('(min-width: 576px)');
            var page = 0;
            var size = desktop.matches ? 3 : (tablet.matches ? 2 : 1);
            var swipe = null;

            if (!cards.length || !stage || !track || !previous || !next || !controls) return;

            var expanders = Array.from(section.querySelectorAll('[data-review-expand]')).map(function (button) {
                var text = document.getElementById(button.getAttribute('aria-controls'));
                if (!text) return null;
                var item = { button: button, text: text, expanded: false };
                button.addEventListener('click', function () {
                    item.expanded = !item.expanded;
                    text.classList.toggle('is-collapsed', !item.expanded);
                    button.setAttribute('aria-expanded', item.expanded ? 'true' : 'false');
                    button.textContent = item.expanded ? section.dataset.reviewCollapseLabel : section.dataset.reviewExpandLabel;
                });
                return item;
            }).filter(Boolean);

            function updateExpanders() {
                expanders.forEach(function (item) {
                    if (item.expanded) return;
                    item.text.classList.add('is-collapsed');
                    var truncated = item.text.scrollHeight > item.text.clientHeight + 1;
                    item.button.hidden = !truncated;
                    item.button.setAttribute('aria-expanded', truncated ? 'false' : 'true');
                    if (!truncated) item.text.classList.remove('is-collapsed');
                });
            }

            function render(animate) {
                var pages = Math.max(1, Math.ceil(cards.length / size));
                page = Math.max(0, Math.min(page, pages - 1));
                track.style.transition = animate ? '' : 'none';
                track.style.transform = 'translate3d(calc(-' + (page * 100) + '% - var(--review-gap) * ' + page + '), 0, 0)';
                cards.forEach(function (card, index) {
                    var visible = index >= page * size && index < (page + 1) * size;
                    if (!visible && card.contains(document.activeElement)) stage.focus({ preventScroll: true });
                    card.inert = !visible;
                    card.setAttribute('aria-hidden', visible ? 'false' : 'true');
                    card.querySelectorAll('a, button').forEach(function (element) {
                        if (visible) element.removeAttribute('tabindex');
                        else element.setAttribute('tabindex', '-1');
                    });
                });
                previous.disabled = page === 0;
                next.disabled = page >= pages - 1;
                controls.hidden = pages <= 1;
                currentPage.textContent = String(page + 1);
                totalPages.textContent = String(pages);
            }

            function move(direction) {
                page += direction;
                render(true);
            }

            previous.addEventListener('click', function () { move(-1); });
            next.addEventListener('click', function () { move(1); });
            stage.addEventListener('keydown', function (event) {
                if (event.defaultPrevented || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey || event.target !== stage) return;
                if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight' && event.key !== 'Home' && event.key !== 'End') return;
                event.preventDefault();
                if (event.key === 'Home') page = 0;
                else if (event.key === 'End') page = Math.ceil(cards.length / size) - 1;
                else page += event.key === 'ArrowRight' ? 1 : -1;
                render(true);
            });
            stage.addEventListener('pointerdown', function (event) {
                swipe = null;
                if (event.isPrimary === false || (event.pointerType !== 'touch' && event.pointerType !== 'pen')) return;
                if (event.target.closest('a, button, input, select, textarea, [contenteditable]')) return;
                swipe = { id: event.pointerId, x: event.clientX, y: event.clientY };
            });
            stage.addEventListener('pointerup', function (event) {
                if (!swipe || event.pointerId !== swipe.id) return;
                var distance = event.clientX - swipe.x;
                var verticalDistance = Math.abs(event.clientY - swipe.y);
                swipe = null;
                if (Math.abs(distance) < 40 || Math.abs(distance) <= verticalDistance * 1.5) return;
                move(distance < 0 ? 1 : -1);
            });
            stage.addEventListener('pointercancel', function () { swipe = null; });

            function resize() {
                var firstIndex = page * size;
                size = desktop.matches ? 3 : (tablet.matches ? 2 : 1);
                page = Math.floor(firstIndex / size);
                swipe = null;
                render(false);
                updateExpanders();
            }

            [desktop, tablet].forEach(function (query) {
                if (query.addEventListener) query.addEventListener('change', resize);
                else if (query.addListener) query.addListener(resize);
            });
            section.classList.add('google-reviews--carousel');
            render(false);
            updateExpanders();
            if (window.ResizeObserver) new ResizeObserver(updateExpanders).observe(stage);
            else window.addEventListener('resize', updateExpanders);
            if (document.fonts && document.fonts.ready) document.fonts.ready.then(updateExpanders);
        });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeReviews);
    else initializeReviews();
})();
